export const orphanTabPrefix = "orphan:";

export const buildConnectionTabs = (connections = [], orphanGroups = []) => [
  ...connections.map(connection => ({
    ...connection,
    value: String(connection.id),
    label: connection.name || connection.number || `Conexión ${connection.id}`,
    orphan: false
  })),
  ...orphanGroups.map(group => ({
    ...group,
    value: `${orphanTabPrefix}${group.id}`,
    label: `${group.name || `Conexión ${group.id}`} (eliminada)`,
    orphan: true
  }))
];

export const getConnectionTabParams = selectedConnectionId => {
  const selectedValue = String(selectedConnectionId || "");
  if (!selectedValue) return {};

  if (selectedValue.startsWith(orphanTabPrefix)) {
    return {
      orphanedConnectionId: selectedValue.replace(orphanTabPrefix, "")
    };
  }

  return selectedValue ? { connectionId: selectedValue } : {};
};

export const buildWhatsappTabs = buildConnectionTabs;
export const getWhatsappTabParams = getConnectionTabParams;

